function TextError (props) {
    return <label className="text-danger label">{props.children}</label>
}
export default TextError